import { render } from "./CollectionStatisticsView.vue?vue&type=template&id=448e0a02&scoped=true"
import script from "./CollectionStatisticsView.vue?vue&type=script&lang=js"
export * from "./CollectionStatisticsView.vue?vue&type=script&lang=js"

import "./CollectionStatisticsView.vue?vue&type=style&index=0&id=448e0a02&scoped=true&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448e0a02"]])

export default __exports__